<template>
  <div class="padding width-100 min-height bg-image" style="background-color: #f6f6f6">
    <div style="height: 80px" class="margin-bs flex-column align-items-star justify-content-center margin-t">
      <div class="flex-row align-items-center justify-content-start width-100">
        <div
          class="margin-r bg-date flex-column align-items-center justify-content-around"
          style="height: 2.5rem; width: 2.5rem"
          @click="show = true"
        >
          <div style="height: 1rem" class="flex-row align-items-center justify-content-center">
            <div class="white fm-sh-regular width-100 fs-sml">{{ year }}</div>
          </div>
          <div class="flex-row align-items-end justify-content-center" style="height: 1.5rem">
            <div class="white fs-20 fw-mid line-height" style="color: #1e67f7">{{ month2 }}</div>
            <div class="white fm-sh-regular fs-sml" style="color: #1e67f7; line-height: 1rem">月</div>
          </div>
        </div>
        <van-image :src="require('../assets/image/leaderboard/title.png')" width="40%" height="2.1rem" fit="contain" />
      </div>
      <div style="color: #a6d1ff; padding-left: 3rem" class="margin-tss width-100">{{ $route.query.name }}</div>
    </div>
    <div class="flex-column align-items-center justify-content-start width-100 bg-white br-reg" style="padding: 5%">
      <div v-if="!(dept_info instanceof Array)" class="flex-row align-items-center justify-content-start width-100 bg-title margin-bs padding-lr">
        <div class="flex-column align-items-star justify-content-center width-100 height-100">
          <div class="white fs-mid-sml margin-bss">{{ dept_info.name }}</div>
          <div class="fs-mid-sml white fm-sh-regular">
            传播值：{{ dept_info.contribution }}
            <span
              v-if="active == 2"
              style="display: inline-block"
              class="margin-ls"
              @click="$router.push({ path: '/personalDetails', query: { month: month } })"
              >查看明细</span
            >
          </div>
        </div>
        <div class="bg-ranking">
          <div class="fm-sc-heavy" style="font-size: 12px; transform: scale(0.9); color: #1e67f7">排名</div>
          <div class="fs-big" style="color: #1e67f7">{{ dept_info.ranking_num }}</div>
        </div>
      </div>
      <div class="width-100 flex-column align-items-center justify-content-start margin-ts">
        <div class="flex-row width-100 align-items-center justify-content-spaceBetween br-big">
          <div style="color: #265df2" class="fw-mid textAlign-c width-20 fs-mid-sml canNotWrap">序号</div>
          <div style="color: #265df2" class="fw-mid width-30 textAlign-c fs-mid-sml canNotWrap">姓名</div>
          <div style="color: #265df2" class="fw-mid width-20 textAlign-c fs-mid-sml canNotWrap">本月签到</div>
          <div style="color: #265df2" class="fw-mid width-20 textAlign-c fs-mid-sml canNotWrap">贡献值</div>
        </div>
        <van-list v-model="loading" :finished="finished" :finished-text="list.length == 0 ? '' : '没有更多了'" @load="onLoad" class="width-100">
          <div
            v-for="(item, key) in list"
            :key="key"
            class="flex-row width-100 align-items-center justify-content-spaceBetween padding-Tb-20"
            style="border-bottom: 1px dashed #979797"
          >
            <div class="textAlign-c fm-sh-regular width-20">{{ key + 1 }}</div>
            <!-- <div v-else class="flex-row width-20 align-items-center justify-content-center">
              <van-image
                :src="
                  key == 0
                    ? require('../assets/image/leaderboard/no1.png')
                    : key == 1
                    ? require('../assets/image/leaderboard/no2.png')
                    : require('../assets/image/leaderboard/no3.png')
                "
                width="1.5rem"
                height="1rem"
              />
            </div> -->
            <div class="width-30 textAlign-c fm-sh-regular fs-sml canNotWrap show-line-1">{{ item.name }}</div>
            <div class="width-20 textAlign-c fm-sh-regular fs-sml" style="padding-right: 5px">{{ item.sign_num }}天</div>
            <div class="width-20 textAlign-c fm-sh-regular fs-sml" style="padding-right: 5px">+{{ item.contribution }}</div>
          </div>
          <van-empty
            v-if="list.length == 0"
            class="custom-image"
            :image="require('../assets/image/prizeManagement/empty-image.png')"
            description="暂无数据"
          />
        </van-list>
      </div>
    </div>
    <div style="margin-bottom: 80px"></div>
    <van-overlay :show="show" class="flex-column align-items-center justify-content-end">
      <van-picker
        title="选择月份"
        show-toolbar
        :default-index="month2 - 1"
        :columns="columns"
        @confirm="onConfirm"
        @cancel="show = false"
        class="width-100"
        style="z-index: 9999"
      />
    </van-overlay>
  </div>
</template>

<script>
import { get_dept_task_info_two } from '../api/leaderboard.js';
export default {
  data() {
    return {
      show: false,
      active: 0,
      loading: false,
      finished: false,
      year: 0,
      month: '2023-08-01',
      month2: 1,
      list: [],
      dept_info: { id: null, name: '', score: '0', ranking_num: '0' },
      columns: [
        { text: '1月', value: 1 },
        { text: '2月', value: 2 },
        { text: '3月', value: 3 },
        { text: '4月', value: 4 },
        { text: '5月', value: 5 },
        { text: '6月', value: 6 },
        { text: '7月', value: 7 },
        { text: '8月', value: 8 },
        { text: '9月', value: 9 },
        { text: '10月', value: 10 },
        { text: '11月', value: 11 },
        { text: '12月', value: 12 }
      ],
      pageNum: 0
    };
  },
  beforeMount() {
    let date = new Date(this.$route.query.month ? this.$route.query.month.split('-').join('/') : '');
    this.year = date.getFullYear();
    this.month2 = date.getMonth() + 1;
    this.month = this.$route.query.month ? this.$route.query.month : date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
  },
  methods: {
    onLoad() {
      this.pageNum += 1;
      this.getList();
    },
    onConfirm(key) {
      this.list = [];
      this.month2 = key.value;
      this.pageNum = 0;
      let date = new Date();
      this.month = date.getFullYear() + '-' + (key.value < 10 ? `0${key.value}` : key.value) + '-' + date.getDate();
      this.onLoad();
      this.show = false;
    },
    async getList() {
      this.loading = true;
      let pageNum = this.pageNum;
      await get_dept_task_info_two({ month: this.month, page: this.pageNum })
        .then((res) => {
          if (res.code == 0) {
            this.list = this.list.concat(res.data.lists);
            if (pageNum == 1) {
              this.dept_info = res.data.info;
            }
            if (res.data.lists.length == 0) {
              this.finished = true;
            }
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.bg-image {
  background-image: url('../assets/image/leaderboard/bg.png');
  background-size: 100%;
  background-repeat: no-repeat;
}
.bg-title {
  background-image: url('../assets/image/leaderboard/bg1.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 4rem;
  position: relative;
}
.bg-date {
  height: 25px;
  width: 25px;
  background-image: url('../assets/image/leaderboard/calendar.png');
  background-size: 100% 100%;
}
.active-tag {
  color: white;
  background: #1e67f7;
  border-radius: 1.25rem;
  font-size: 14px;
  height: 28px;
  line-height: 28px;
}
.normal-tag {
  color: #1e67f7;
  font-size: 14px;
  height: 28px;
  line-height: 28px;
}
.bg-ranking {
  position: absolute;
  right: 10%;
  top: 0;
  background-image: url('../assets/image/leaderboard/rank.png');
  background-size: 100% 100%;
  width: 50px;
  height: 50px;
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
::v-deep .van-overlay {
  z-index: 1000 !important;
}
</style>
